import { render, staticRenderFns } from "./serviceHoursDescription.vue?vue&type=template&id=77da0bdc&scoped=true&"
import script from "./serviceHoursDescription.vue?vue&type=script&lang=js&"
export * from "./serviceHoursDescription.vue?vue&type=script&lang=js&"
import style0 from "./serviceHoursDescription.vue?vue&type=style&index=0&id=77da0bdc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77da0bdc",
  null
  
)

export default component.exports